export default __webpack_public_path__ + "static/media/projeto3.29f6d7bf.svg";